// todo: maybe replace 'online' flag by using VIDEO_WINDOW_STATE_OFFLINE windowState

import {
    VIDEO_WINDOW_OPEN,
    VIEW_USER_REQUEST,
    VIEW_USER_SUCCESS,
    VIDEO_CANPLAY,
    VIEW_USER_STOP,
    VIEW_USER_RECONNECT,
    VIDEO_WINDOW_CLOSE,
    VIEW_LEAVE,
    STREAM_LIMIT_REACHED,
    STREAM_STREAM_UPDATE,
    VIEW_FULLSCREEN,
    VIEW_WINDOW,
    VIEW_WINDOW_RESIZE,
    WINDOW_MEDIUM,
    WINDOW_SMALL,

    VIEW_STOP_REASON_LIMIT_REACHED,
    VIEW_STOP_REASON_WATCH_CLOSED,

    VIDEO_WINDOW_STATE_OPENED,
    VIDEO_WINDOW_STATE_CONNECTING,
    VIDEO_WINDOW_STATE_CONNECTED,
    VIDEO_WINDOW_STATE_ONLINE,
    VIDEO_WINDOW_STATE_PAUSED,
    VIDEO_WINDOW_STATE_OFFLINE,
    VIDEO_WINDOW_STATE_BLOCKED,
    VIDEO_WINDOW_STATE_LIMIT_REACHED
} from '../constants/streaming';

import {
    ROOM_CLIENT_UPDATE,
    ROOM_CLIENT_LOGOUT
} from '../constants/users'

import {
    CURRENT_USER_BLOCKED,
    CURRENT_USER_UNBLOCKED
} from '../constants/block';

import { CLOSE } from '../constants/general';
import {ROOM_SWITCHED} from '../constants/rooms';

export default function videoStreams(state = {}, action) {
    if (action.type == VIDEO_WINDOW_OPEN) {
        let stream_id = action.stream_id;
        let stream = action.streamer.streams[stream_id];
        // user offline
        if (!action.streamer) return state;

        // no streaming
        if (!stream) return state;

        let windowStateInitial = VIDEO_WINDOW_STATE_OPENED;
        if (stream.paused) windowStateInitial = VIDEO_WINDOW_STATE_PAUSED;

        // video window already opened
        if (state[stream_id]) {
            return {
                ...state,
                [stream_id]: {
                    ...state[stream_id],
                    online: true,
                }
            }
        }

        let videoStream = {
            stream_id: stream_id,
            streamer: action.streamer,
            hitagi_stream: stream,
            fullscreen: false,
            stream: null,
            user: action.streamer,
            online: true,
            size: action.browser.phone ? WINDOW_MEDIUM : WINDOW_SMALL,
            timeoutHandle: undefined,
            windowState: action.windowStateOverride || windowStateInitial
        };

        return {
            ...state,
            [stream_id]: videoStream
        };
    }

    if (action.type == VIEW_USER_REQUEST) {
        let stream_id = action.stream_id;
        let stream = action.streamer.streams[stream_id];
        if (state[stream_id]) {
            let windowState = state[stream_id].windowState;

            return {
                ...state,
                [stream_id]: {
                    ...state[stream_id],
                    timeoutHandle: undefined,
                    windowState: windowState != VIDEO_WINDOW_STATE_PAUSED ? VIDEO_WINDOW_STATE_CONNECTING : windowState
                }
            }
        }
    }

    if (action.type == VIEW_USER_SUCCESS) {
        let stream_id = action.stream_id;
        let stream = action.streamer.streams[stream_id];

        if (state[stream_id]) {
            let windowState = state[stream_id].windowState;

            return {
                ...state,
                [stream_id]: {
                    ...state[stream_id],
                    stream: action.stream,
                    online: true,
                    windowState: windowState != VIDEO_WINDOW_STATE_PAUSED ? VIDEO_WINDOW_STATE_CONNECTED : windowState
                }
            }
        }
    }

    if (action.type == VIDEO_CANPLAY) {
        let stream_id = action.stream_id;

        if (state[stream_id]) {
            let windowState = state[stream_id].windowState;

            return {
                ...state,
                [stream_id]: {
                    ...state[stream_id],
                    windowState: windowState != VIDEO_WINDOW_STATE_PAUSED ? VIDEO_WINDOW_STATE_ONLINE : windowState
                }
            }
        }
    }

    if (action.type == VIEW_USER_RECONNECT) {
        let stream_id = action.stream_id;
        let stream = action.streamer.streams[stream_id];

        if (state[stream_id]) {
            return {
                ...state,
                [stream_id]: {
                    ...state[stream_id],
                    online: true,
                    stream: action.stream,
                }
            }
        }
    }

    if (action.type == VIEW_USER_STOP
     //|| action.type == ROOM_CLIENT_LOGOUT
     ) {
        let stream_id = action.stream_id;

        if (stream_id && state[stream_id]) {
            let online = action.type === ROOM_CLIENT_LOGOUT ? false : state[stream_id].online;

            let windowState = VIDEO_WINDOW_STATE_OFFLINE;

            if (action.reason === VIEW_STOP_REASON_LIMIT_REACHED) {
                windowState = VIDEO_WINDOW_STATE_LIMIT_REACHED;
            }

            if (action.reason === VIEW_STOP_REASON_WATCH_CLOSED && state[stream_id].windowState == VIDEO_WINDOW_STATE_LIMIT_REACHED) {
                windowState = VIDEO_WINDOW_STATE_LIMIT_REACHED;
            }

            if (action.reason === "VIEWS_LIMIT_REACHED") {
                let newState = Object.assign({}, state);
                delete newState[action.stream_id];

                return newState;
            }

            return {
                ...state,
                [stream_id]: {
                    ...state[stream_id],
                    stream: null,
                    online: online,
                    timeoutHandle: action.timeoutHandle || state[stream_id].timeoutHandle,
                    windowState: windowState
                }
            }
        }
    }
    
    if (action.type == VIEW_FULLSCREEN || action.type == VIEW_WINDOW) {
        let stream_id = action.stream_id;
        let uid = action.uid;


        if (state[stream_id]) {
            let newState = {...state};
            for (let i in newState) {
                if (newState[i].user.uid == uid && i != stream_id) {
                    newState[i] = {
                        ...newState[i],
                        fullscreen: false,
                        pop: (action.type == VIEW_FULLSCREEN)
                    }
                }
            }
            newState[stream_id] = {
                ...newState[stream_id],
                fullscreen: (action.type == VIEW_FULLSCREEN),
                pop: false
            }
            return newState;
        }
    }

    if (action.type == VIEW_FULLSCREEN || action.type == VIEW_WINDOW) {
        if (state[action.stream_id]) {
            return {
                ...state,
                [action.stream_id]: {
                    ...state[action.stream_id],
                    fullscreen: (action.type == VIEW_FULLSCREEN)
                }
            }
        }
    }

    if (action.type == VIEW_WINDOW_RESIZE) {
        return {
            ...state,
            [action.stream_id]: {
                ...state[action.stream_id],
                size: action.size
            }
        };
    }

    if (action.type == ROOM_SWITCHED) {
        return {};
    }

    if (action.type === CLOSE) {


        return state;
    }

    if (action.type === ROOM_CLIENT_UPDATE) {
        let newState = {...state};

        for (let stream_id in action.user.streams) {
            let stream = action.user.streams[stream_id];

            if (state[stream_id]) {
                let windowState = state[stream_id].windowState;
                if (stream.paused) {
                    if ([VIDEO_WINDOW_STATE_CONNECTING, VIDEO_WINDOW_STATE_CONNECTED, VIDEO_WINDOW_STATE_ONLINE].indexOf(windowState) != -1) {
                        windowState = VIDEO_WINDOW_STATE_PAUSED;
                    }
                } else {
                    if (windowState == VIDEO_WINDOW_STATE_PAUSED) windowState = VIDEO_WINDOW_STATE_ONLINE;
                }

                newState = {
                    ...newState,
                    [stream_id]: {
                        ...state[stream_id],
                        windowState: windowState,
                        hitagi_stream: stream,
                        streamer: action.user
                    }
                }
            }
        }

        return newState;
        
    }

    if (action.type === VIDEO_WINDOW_CLOSE) {
        if (state[action.stream_id]) {
            let newState = Object.assign({}, state);
            delete newState[action.stream_id];

            return newState;
        }
    }

    if (action.type === VIEW_LEAVE) {
        if (state[action.ufrag]) {
            let windowState = state[action.ufrag].windowState;

            return {
                ...state,
                [action.ufrag]: {
                    ...state[action.ufrag],
                    stream: null,
                    windowState: windowState != VIDEO_WINDOW_STATE_BLOCKED ? VIDEO_WINDOW_STATE_OFFLINE : windowState
                }
            }
        }
    }

    if (action.type == CURRENT_USER_BLOCKED) {
        for (let ufrag in state) {
            if (state[ufrag].user && state[ufrag].user.uid == action.uid) {
                return {
                    ...state,
                    [ufrag]: {
                        ...state[ufrag],
                        windowState: VIDEO_WINDOW_STATE_BLOCKED
                    }
                }
            }
        }
    }

    if (action.type == CURRENT_USER_UNBLOCKED) {
        for (let ufrag in state) {
            if (state[ufrag].user && state[ufrag].user.uid == action.uid) {
                let user = state[ufrag].user;

                return {
                    ...state,
                    [ufrag]: {
                        ...state[ufrag],
                        windowState: user.paused ? VIDEO_WINDOW_STATE_PAUSED : VIDEO_WINDOW_STATE_CONNECTING
                    }
                }
            }
        }
    }

    if (action.type == STREAM_LIMIT_REACHED) {
        let newState = Object.assign({}, state);
        for (let stream_id in newState) {
            newState[stream_id].stream = null;
            newState[stream_id].windowState = VIDEO_WINDOW_STATE_LIMIT_REACHED;
        }

        return newState;
    }

    if (action.type === STREAM_STREAM_UPDATE) {
        let newState = {...state};
        for (let stream_id in newState) {
            if (action.data[stream_id]) {
                newState[stream_id].hitagi_stream = action.data[stream_id];
            }
        }
        return newState;
    }



    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/videoStreams.js